import React from 'react';
import { useSelector } from 'react-redux';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  {
    name: 'Page A',
    collection: 4000,
    disbursement: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    collection: 3000,
    disbursement: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    collection: 2000,
    disbursement: 9800,
    amt: 2290,
  },
  {
    name: 'Page D',
    collection: 2780,
    disbursement: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    collection: 1890,
    disbursement: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    collection: 2390,
    disbursement: 3800,
    amt: 2500,
  },
  {
    name: 'Page G',
    collection: 3490,
    disbursement: 4300,
    amt: 2100,
  },
];

const RevenueGraph = () => {
  const {dashboardData} =  useSelector((state)=>state.fetch) 
  return (
    <div className="service-card  w-full h-full mt-[1.25rem] p-5">
      <div className="heading_4">Statistics</div> 
      <div className="paragraph_1 mb-[1.25rem]">Collection and Disbursement</div> 
    <ResponsiveContainer width="100%" height="80%">
      <LineChart
        data={dashboardData?.organizationData}
        // data={data}
        margin={{
          top: 5,
          right: 30,
          left: 80,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend layout="horizontal" verticalAlign="top" align="center" />
 
        <Line type="monotone" dataKey="disbursement" stroke="#8884d8" activeDot={{ r: 8 }} />
        <Line type="monotone" dataKey="collection" stroke="#82ca9d" />
      </LineChart>
    </ResponsiveContainer>
    </div>
  );
};

export default RevenueGraph;
